import { roundToStrike } from "@/lib/options/structure";
import type { Mode, Regime } from "@/types/options";
import { defineStrategy } from "./define";
import { leg } from "./leg";
import { offsetParam, toggleParam } from "./params";
import { scale } from "./scale";

export const jadeLizard = defineStrategy(
  "jade_lizard",
  "Jade Lizard",
  "income",
  {
    defaultParams: () => ({
      direction: 1,
      nakedOffset: 30,
      spreadShortOffset: 20,
      spreadLongOffset: 40,
    }),
    paramSchema: [
      toggleParam("direction", "Direction", [
        [1, "Standard"],
        [-1, "Reverse"],
      ]),
      offsetParam("nakedOffset", "Naked Leg Offset", 5, 80, 0),
      offsetParam("spreadShortOffset", "Spread Short Offset", 5, 80, 1),
      offsetParam("spreadLongOffset", "Spread Long Offset", 10, 120, 2),
    ],
    scaleParams: (r: Regime, m: Mode, cur: Record<string, number>) => ({
      direction: cur.direction ?? 1,
      nakedOffset: scale(30, r, m, true),
      spreadShortOffset: scale(20, r, m, true),
      spreadLongOffset: scale(40, r, m, false),
    }),
    toLegs: (spot, params, strikeStep) => {
      const center = roundToStrike(spot, strikeStep);
      if (params.direction >= 0) {
        return [
          leg(center - params.nakedOffset, "put", "short"),
          leg(center + params.spreadShortOffset, "call", "short"),
          leg(center + params.spreadLongOffset, "call", "long"),
        ];
      }
      return [
        leg(center + params.nakedOffset, "call", "short"),
        leg(center - params.spreadShortOffset, "put", "short"),
        leg(center - params.spreadLongOffset, "put", "long"),
      ];
    },
  },
);
